/*
  Shared scroll-reveal behavior for the denim-lp-* sections.
  Included (once or many times, safely) by every section that has
  [data-reveal], [data-reveal-left], [data-reveal-right] or [data-cta-reveal]
  elements, so the observer logic only lives in one place.
*/
(function () {
  function init() {
    if (window.__denimLpRevealInitialized) return;
    window.__denimLpRevealInitialized = true;

    var reduceMotion = false;
    try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    function observe(selector, threshold) {
      var els = document.querySelectorAll(selector);
      if (!els.length) return;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        els.forEach(function (n) { n.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, { threshold: threshold });
      els.forEach(function (n) { observer.observe(n); });
    }

    observe('[data-reveal]', 0.1);
    observe('[data-reveal-left]', 0.1);
    observe('[data-reveal-right]', 0.1);
    observe('[data-cta-reveal]', 0.4);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
